import React, { useEffect, useState } from "react";
import "./profile.scss";
import CancelSaveHeader from "../../components/customPageHeader/CancelSaveHeader";
import { useAuth } from "../../contexts/auth";
import defaultProfilePic from "../../assets/profilepic.jpg";
import "../../components/typographyText/styles.scss";
import CustomTextBox from "../../components/customTextBox/CustomTextBox";
import CustomChangePwdPopup from "../../components/customPopup/CustomChangePwdPopup";
import CustomDropdown from "../../components/customDropDown/CustomDropdown";
import { ToastDisplayer } from "../../components/toastDisplay/ToastDisplayer";
import { generateOtpWithAction } from "../../api/forgotPwdApi";
import { LoadPanel } from "devextreme-react";
import {
  editCompanyByEmailApi,
  getCompanyByEmailApi,
} from "../../api/companyApi";
import { useNavigate } from "react-router-dom";

export default function CompanyProfile() {
  const navigate = useNavigate();
  const [isProflePopupVisible, setisProflePopupVisible] = useState(false);

  const { user, setUser } = useAuth();
  const [isHovered, setIsHovered] = useState(false);
  const [image, setImage] = useState();
  const [dispimage, setDispImage] = useState();
  const [loading, setLoading] = useState(false);
  const [cmpData, setCmpData] = useState("");
  const [errors, setErrors] = useState(false);
  

  const [formData, setFormData] = useState({
    registeredAddress: "",
    contactNumber: "",
    // companyavatar:""
  });
  const validateForm = () => {
    const newErrors = {};

    if (!formData.contactNumber) {
      newErrors.contactNumber = "Contact number is required.";
    } else if (!/^\d{3,15}$/.test(formData.contactNumber)) {
      newErrors.contactNumber =
        "Contact number must be numeric and should be between 3 to 15";
    }

    if (!formData.registeredAddress)
      newErrors.registeredAddress = "Address is required.";

    setErrors(newErrors);
    Object.values(newErrors).forEach((error) => {
      ToastDisplayer("error", error);
    });
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const fetchCompany = async () => {
      if (user) {
        try {
          setLoading(true);
          const result = await getCompanyByEmailApi(
            user?.email,
            user?.access_token,
          );
          if (result.status === 200) {
            setFormData({
              registeredAddress: result?.data.data.companyaddress || "",
              contactNumber: result?.data.data.companyphno || "",
              // companyavatar: result?.data.data.companyaddress || "",
            });
            // console.log(
            //   "email of registeredAddress : ",
            //   result?.data?.data?.companyaddress,
            // );
            // console.log(
            //   "email of contactNumber : ",
            //   result?.data?.data?.companyphno,
            // );

            setCmpData(result.data.data);
          }
        } catch (error) {
          ToastDisplayer(
            "error",
            error.response?.data?.error || "An unexpected error occurred.",
          );
        } finally {
          setLoading(false);
        }
      }
    };

    fetchCompany();
  }, []);

  const handleImageClick = (e) => {
    e.preventDefault();
    document.getElementById("profileImage").click();
  };

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];

  //   if (file) {
  //     const reader = new FileReader();

  //     reader.onload = () => {
  //       setImage(reader.result);
  //       setDispImage(reader.result.split(",")[1]);
  //     };

  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        setImage(reader.result);
        setDispImage(base64String);
      };

      reader.readAsDataURL(file);
    }
  };

  const handleImageHover = (isHovering) => {
    setIsHovered(isHovering);
  };

  const handleProfileSaveDetails = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      // const cmpLogo=dispimage===undefined ? cmpData.companyavatar : dispimage
      var result;
      if (dispimage !== undefined) {
        result = await editCompanyByEmailApi(
          user?.email,
          formData.registeredAddress,
          formData.contactNumber,
          dispimage,
          // cmpLogo
        );  
      } else {
        result = await editCompanyByEmailApi(
          user?.email,
          formData.registeredAddress,
          formData.contactNumber,
        );
      }

      if (result.status === 200 ) {
        if (dispimage != undefined) {
          setUser((prevUser) => ({
            ...prevUser,
            companyavatar: dispimage,
            // companyavatar: cmpLogo,
          }));
          const getSess = JSON.parse(sessionStorage.getItem("authState")) || {};
          const updSess = { ...getSess, companyavatar: dispimage };
          // const updSess = { ...getSess, companyavatar: cmpLogo };
          sessionStorage.setItem("authState", JSON.stringify(updSess));
        }

        ToastDisplayer("success", result.data.message);

        // navigate("/");
      }
    } catch (error) {
      ToastDisplayer("error", error.response.data.error);
    } finally {
      setLoading(false);
    }
  };

  const toggleProfileOtpPopup = async () => {
    // sending otp when clicked on change password
    try {
      setLoading(true);

      const otpResult = await generateOtpWithAction(user.email, "R");
      ToastDisplayer(
        otpResult?.status === 200 ? "success" : "error",
        otpResult?.status === 200
          ? otpResult.data.message
          : "OTP generation failed",
      );

      setisProflePopupVisible(!isProflePopupVisible);
    } catch (error) {
      ToastDisplayer("error", error.response?.data?.error || error.message);
    } finally {
      setLoading(false);
    }
  };

  const toggleProfileCloseFromPopup = async () => {
    setisProflePopupVisible(!isProflePopupVisible);
  };

  const handleInputChange = (name) => (e) => {
    const value = e.value;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  useEffect(() => {
    if (user?.companyavatar) {
      setImage(`data:image/jpeg;base64,${user?.companyavatar}`);
    } else {
      setImage("");
    }
  }, [user]);

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <div className="ProfilePage">
        <CancelSaveHeader
          titleName={"Comapany Profile"}
          handleDetCancel={handleCancel}
          handleDetSave={handleProfileSaveDetails}
        />

        <div className="profileMain">
          <div className="mainProfileSection">
            <div className="profileUpper">
              <div
                className={`user-image-container ${isHovered ? "hovered" : ""}`}
                onMouseEnter={() => handleImageHover(true)}
                onMouseLeave={() => handleImageHover(false)}
              >
                <label htmlFor="profileImage">
                  <img src={image || defaultProfilePic} alt="Profile" />
                </label>
                {isHovered && (
                  <div className="hover-icon" onClick={handleImageClick}>
                    <i class="ri-user-add-line"></i>
                  </div>
                )}
                <input
                  type="file"
                  id="profileImage"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
              </div>
              <div className="profileContent">
                <div className="typ-header-text">
                  {user?.login_name || user?.email?.split("@")[0] || "Username"}
                </div>
                <div className="typ-sub-text">
                  <span style={{ fontWeight: 600 }}>Email ID </span>:{" "}
                  {user?.email}
                </div>
                <div
                  className="custom-profile-text"
                  onClick={toggleProfileOtpPopup}
                >
                  Change Password
                </div>
              </div>
            </div>
            {/* <div className="profileFields">
              <div className="fieldsMain">
                <div className="detail-small-light">
                  Company Name <span className="required">*</span>
                </div>
                <div className="detail-mid-light">{cmpData.companyname}</div>
              </div>
              <div className="fieldsMain">
                <div className="detail-small-light">
                  Company Email <span className="required">*</span>
                </div>
                <div className="detail-mid-light">{cmpData.companyemail}</div>
              </div>
            </div> */}
          </div>
          <div className="editProfileSection">
            <div className="lowerSecProfile">
              <CustomTextBox
                label="Registered Address"
                placeholder="Registered Address"
                value={formData.registeredAddress}
                onChange={handleInputChange("registeredAddress")}
                type="text"
              />

              <CustomTextBox
                label="Contact Number"
                placeholder="Contact Number"
                value={formData.contactNumber}
                onChange={handleInputChange("contactNumber")}
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <CustomChangePwdPopup
        visible={isProflePopupVisible}
        // onClose={toggleProfileOtpPopup}
        onClose={toggleProfileCloseFromPopup}
        loading={loading}
        setLoading={setLoading}
      />
    </>
  );
}
